import alert from '@src/components/modal/alert';
import styles from './index.less';

export default function remind(text, duration, componentContext) {
  return alert(
    {
      title: text,
      duration,
      finalClassName: styles.root
    },
    componentContext
  );
}
